import {Component, Input, OnInit} from '@angular/core';
import { GadgetApiService, PageNotificationService } from '@signature-it/ngx-generic/services';
import { RestUrlsConfig, GenericConfig } from '@signature-it/ngx-generic/config';

@Component({
    selector: 'list-text-gadget',
    templateUrl: './list-text.gadget.html',
    styleUrls: ['./list-text.gadget.scss'],
    standalone: false
})
export class ListTextGadget {
    @Input() data: Array<any>;
    @Input() dataCount: number;
    @Input() title: string;

    open = false;

    constructor() {}

}
